import {post} from 'app/utils/http_request_helper';

const getCsrfToken = () => self.csrf_token || document.head.querySelector('[name=csrf-token]').content;

export const sendNotificationLog = (browser_notification_id, topic, event_type) => {
    const token = window.localStorage.getItem(`sentFirebaseMessagingToken_${window.USER_UI_DATA.user_id}`);

    if (!token) {
        return console.log(`Sending notification log topic: ${topic} event_type: ${event_type}`);
    }
    return post(`/devices/${token}/notification_log`, {
        browser_notification_id,
        event_type
    }, {'X-CSRF-Token': getCsrfToken()});
};
